<div class="c-progressbagInfo2">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-progressbagInfo2__container">
    <span class="text title">{{ 'home.live-ops.progressbag.modal-info-2.title' | translate }}</span>

    <div class="c-progressbagInfo2__containerCenter">
      <div class="c-progressbagInfo2__containerRight">
        <div
          class="image"
          theming
          themingGroup="progressivebag"
          themingAsset="step-4"
          [themingOverride]="progressbag()?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.progressbag.modal-info-2.step-1' | translate }}</span>
      </div>

      <div class="c-progressbagInfo2__containerLeft">
        <div class="c-pointsTable">
          @for (item of progressbag().properties.pointspercurrency; track item; let i = $index) {
            <slotcom-box
              [classes]="[
                'progressBagPointsPerCurrency',
                i % 2 ? 'progressBagPointsPerCurrencyOdd' : 'progressBagPointsPerCurrencyEven'
              ]">
              @if (i === 0) {
                <span class="text currency"
                  >{{ item.currency + 0.01 | number: '1.2-2' : ('common.culture' | translate) }}€ -
                  {{
                    progressbag().properties.pointspercurrency[1].currency
                      | number: '1.2-2' : ('common.culture' | translate)
                  }}€</span
                >
              }
              @if (i === progressbag().properties.pointspercurrency.length - 1) {
                <span class="text currency">
                  {{ 'home.live-ops.progressbag.more-than' | translate }}
                  {{
                    progressbag().properties.pointspercurrency[progressbag().properties.pointspercurrency.length - 1]
                      .currency | number: '1.2-2' : ('common.culture' | translate)
                  }}€
                </span>
              }
              @if (i !== 0 && i !== progressbag().properties.pointspercurrency.length - 1) {
                <span class="text currency">
                  {{ item.currency + 0.01 | number: '1.2-2' : ('common.culture' | translate) }}€ -
                  {{
                    progressbag().properties.pointspercurrency[i + 1].currency
                      | number: '1.2-2' : ('common.culture' | translate)
                  }}€
                </span>
              }
              <span class="arrow"></span>
              <span class="text points d-flex align-items-center justify-content-end"
                >{{ item.points
                }}<span
                  class="type-icon-text"
                  theming
                  themingGroup="progressivebag"
                  themingAsset="icon-points"
                  [themingOverride]="progressbag()?.assets"></span
              ></span>
            </slotcom-box>
          }
        </div>

        <span
          class="text subtitle-2"
          [ngClass]="progressbag().properties.pointspercurrency.length >= 7 ? 'no-margin' : ''"
          >{{ 'home.live-ops.progressbag.modal-info-2.step-2' | translate }}</span
        >
      </div>
    </div>

    <div class="c-progressbagInfo2__footer">
      <slotcom-button
        class="c-button--pink"
        (safeClick)="openInfo1()"
        audioType="functionality">
        {{ 'home.live-ops.progressbag.modal-info.title' | translate | uppercase }}
      </slotcom-button>
    </div>
  </div>
</div>
